import React, { memo } from 'react';

export const AttentiveLoader = memo(() => {
  return (
    <div className='flex justify-center align-center flex-column' style={{ width: '100vw', height: '100vh' }}>
      <img
        alt='Beam logo'
        src='https://storage.googleapis.com/falcon-shared-images-front-end/beam-loader.avif'
        height='140'
        className='mb'
      />
    </div>
  );
});
